import { apiPost, authorisationHeader } from '@/utils/httpClient'

export const authenticationApi = {
    userLogin(accessToken: string) {
        const config = authorisationHeader(accessToken);
        return apiPost('authentication/login', {}, false, config);
    },

    userLogout() {
        return apiPost('authentication/logout');
    }
}